const map = {
	"./global/en-US.js": 79786,
	"./global/zh-CN.js": 70320,
	"./login/en-US.js": 95802,
	"./login/zh-CN.js": 62048,
	"./mfa/en-US.js": 43453,
	"./mfa/zh-CN.js": 27027,
	"./utils/en-US.js": 35342,
	"./utils/zh-CN.js": 6084
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97783;